<template>
  <!-- Główny kontener filtrów -->
  <div class="filters-container">
    <!-- Komponent do filtrowania po lokalizacjach (przekazuje store jako props) -->
    <locations-filter-view :store="filtersStore" />

    <!-- Komponent do filtrowania po znakach (przekazuje store jako props) -->
    <signs-filter-view :store="filtersStore" />

    <!-- Sekcja legendy opisującej statusy znaków -->
    <div class="filter d-flex flex-column">
      <h5>
        {{ t('legend') }}
        <!-- Ikona rozwijania/zwijania legendy (na razie zakomentowana) -->
        <!--
        <span
          class="icon-collapse margin-0"
          data-bs-toggle="collapse"
          href="#legend"
          role="button"
          aria-expanded="true"
          aria-controls="legend"
        ></span>
        -->
      </h5>
      <!-- Widoczna (show) domyślnie legenda statusów -->
      <div class="info collapse show" id="legend">
        <!-- Każdy wiersz to inny status oraz jego opis -->
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-ok"></div>
          <div class="col-7 p-0">{{ t('available') }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-not-ok"></div>
          <div class="col-7 p-0">{{ t('unavailable') }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-error"></div>
          <div class="col-7 p-0">{{ t('malfunction') }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-on"></div>
          <div class="col-7 p-0">{{ t('enabled') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import komponentów filtrów oraz Pinia store
import LocationsFilterView from "./filters/LocationsFilterView.vue";
import SignsFilterView from "./filters/SignsFilterView.vue";
import { useVmsFilterStore } from "@/stores/vmsFilters";

export default {
  name: "FilterVmsData",
  // Rejestracja komponentów jako child components
  components: {
    LocationsFilterView,
    SignsFilterView,
  },
  setup() {
    // Inicjalizacja store Pinia dla filtrów VMS
    const filtersStore = useVmsFilterStore();
    // Zwracamy store do template jako zmienna reaktywna
    return { filtersStore };
  },
};
</script>

<style scoped>
/* Kontener filtrów z tłem graficznym */
.filters-container {
  background: var(--surface-secondary);
}
/* Nagłówek sekcji legendy */
.filter h5 {
  /* margin: 0; */
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--surface-primary);
  position: relative;
  background: var(--surface-primary);
}
/* Wiersze legendy */
.row {
  height: var(--control-height);
  line-height: 25px;
}
/* Kontener z opisami statusów */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}
/* Paragrafy w legendzie */
.info p {
  font-size: var(--font-size-sm);
  margin: 0;
}
/* Ikona do rozwijania/zwijania legendy */
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
/* Styl dla zminimalizowanej ikony */
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}
</style>
